import { Quote } from "lucide-react";

const TestimonialSection = () => {
  return (
    <section className="py-20 bg-muted">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center">
          <div className="flex justify-center mb-6">
            <div className="w-16 h-16 bg-accent rounded-full flex items-center justify-center">
              <Quote className="w-8 h-8 text-accent-foreground" />
            </div>
          </div>

          <blockquote className="text-xl md:text-2xl font-medium text-foreground mb-6 leading-relaxed">
            "Khuleg Cargo түргэн шуурхай, найдвартай үйлчилгээ үзүүлдэгт
            баярлалаа"
          </blockquote>

          <p className="text-muted-foreground">— Манай үйлчлүүлэгч</p>
        </div>
      </div>
    </section>
  );
};

export default TestimonialSection;
